var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[(true)?_c('oa-page',{staticClass:"pb-8",attrs:{"slug":"about"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }